import React from 'react';
import Page, { Grid, GridColumn } from '@atlaskit/page';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import iContactCompanyProduct from '../../../types/contactCompany/iContactCompanyProduct';
import DateTimePickerWithController from '../../form/hookForms/DateTimePickerWithController';
import InputWithController from '../../form/hookForms/InputWithController';
import AsyncCreatableWithController from '../../form/hookForms/AsyncCreatableWithController';
import LinkBtnUrl from '../../buttons/LinkBtnUrl';
import ComposeSecondaryText from '../../text/ComposeSecondaryText';
import CustomizedLabel from '../../form/hookForms/CustomizedLabel';
import ConversionCalculateController from '../../conversionCalculate/ConCalculateController';
import { PRODUCTS_URL } from '../../UrlMap';
import { handleNullException } from '../../../services/UtilsService';
import { mapLabelValuePairObjPayload } from '../../../pages/sales/utilities';
import {
  getCustomerListAsyncSearch,
  getSupplierListAsyncSearch,
} from '../../../services/ContactCompanyService';
import { FlexContainer, SpaceVerticalContainer } from '../../styles/styles';

const CCPCreateOrderModalBody = ({
  control,
  errors,
  onChange,
  isCustomer,
  isServiceProvider,
  ccp,
}: {
  // eslint-disable-next-line
  control: Control<Record<string, any>>;
  // eslint-disable-next-line
  onChange: (name: string, value: any, config?: Object) => void;
  // eslint-disable-next-line
  errors?: DeepMap<Record<string, any>, FieldError>;
  isCustomer: boolean;
  isServiceProvider?: boolean;
  ccp: iContactCompanyProduct;
}) => {
  const swapLabel = isServiceProvider ? 'Service Provider' : 'Supplier';
  return (
    <Page>
      <Grid testId={'full-grid'}>
        <GridColumn medium={12}>
          <AsyncCreatableWithController
            label={isCustomer ? 'Customer' : swapLabel}
            name={isCustomer ? 'customerId' : 'supplierId'}
            control={control}
            // eslint-disable-next-line
            onChange={(name: string, value: any, config?: Object) =>
              onChange(name, value.id, config)
            }
            errors={errors}
            promiseFn={
              isCustomer
                ? getCustomerListAsyncSearch
                : getSupplierListAsyncSearch
            }
            optionLabel={'name'}
            isRequired
            defaultValue={
              ccp.contactCompany
                ? mapLabelValuePairObjPayload([ccp.contactCompany], 'name')[0]
                : undefined
            }
            isCreatable={false}
            isDisabled
          />
        </GridColumn>
        <GridColumn medium={12}>
          <InputWithController
            label={isCustomer ? 'Customer Reference' : `${swapLabel} Reference`}
            name={isCustomer ? 'customerRef' : 'supplierRef'}
            control={control}
            onChange={onChange}
            errors={errors}
            isRequired={isCustomer}
          />
        </GridColumn>
        <GridColumn medium={12}>
          <DateTimePickerWithController
            label={'Order Date'}
            name={'orderDate'}
            control={control}
            onChange={onChange}
            errors={errors}
            isRequired
            isDateOnly
            isDefaultNow
          />
        </GridColumn>
        <GridColumn medium={12}>
          <SpaceVerticalContainer className={'half'} />
          <FlexContainer className={'space-between'}>
            <CustomizedLabel label={isCustomer ? 'SO Items' : 'PO Items'} />
            <CustomizedLabel label={'Quantity'} />
          </FlexContainer>
          <SpaceVerticalContainer className={'quarter'} />
          <FlexContainer className={'space-between flex-start'}>
            <ComposeSecondaryText
              secondaryText={handleNullException(ccp, 'product.name')}
            >
              <LinkBtnUrl
                btnName={handleNullException(ccp, 'product.productCode')}
                url={`${PRODUCTS_URL}/${handleNullException(ccp, 'productId')}`}
              />
            </ComposeSecondaryText>

            <ConversionCalculateController
              label={''}
              name={'qty'}
              defaultValue={'0'}
              control={control}
              errors={errors}
              contactCompanyUnit={handleNullException(
                ccp,
                'measurement.shortName',
              )}
              productUnit={handleNullException(
                ccp,
                'product.measurement.shortName',
              )}
              conversion={Number(ccp.unitConversion) || 1}
            />
          </FlexContainer>
        </GridColumn>
      </Grid>
      <Grid>
        <SpaceVerticalContainer className={'two'} />
      </Grid>
    </Page>
  );
};

export default CCPCreateOrderModalBody;
